import { jsx as _jsx } from "react/jsx-runtime";
import { classNameParserCore } from "../../coreFunctions/classNameParserCore/classNameParserCore";
import "./icon-core.scss";
export const IconCore = ({ src, className = "", width = 11, height = 12, onClick, containerStyle = {}, }) => {
    return (_jsx("div", { className: classNameParserCore("icon-core-container", className), style: Object.assign({}, containerStyle), onClick: onClick, children: _jsx("img", { src: src, alt: "Icon", width: width, height: height }) }));
};
